import React, { useState } from 'react';
import { TouchableOpacity, Text, StyleSheet, TouchableOpacityProps } from 'react-native';

interface DebounceButtonProps extends TouchableOpacityProps {
  onPress?: () => void;
  debounceTime?: number; // 防止重复点击的时间，默认 1000ms
  children?: React.ReactNode;
}

const DebounceButton: React.FC<DebounceButtonProps> = ({ 
  onPress, 
  debounceTime = 1000,
  children,
  disabled = false,
  style,
  ...rest
}) => {
  const [isDisabled, setIsDisabled] = useState(false);

  const handlePress = () => {
    if (isDisabled || disabled) return;

    setIsDisabled(true);
    if(onPress){
      onPress();
    }
  
    setTimeout(() => {
      setIsDisabled(false);
    }, debounceTime);
  };

  const mergedDisabled = isDisabled || disabled;

  return (
    <TouchableOpacity
      onPress={handlePress}
      disabled={mergedDisabled}
      style={[style, mergedDisabled && { opacity: 0.6 }]}
      {...rest}
    >
     {children}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  buttonText: {
    padding: 10,
    backgroundColor: '#007bff',
    color: '#fff',
    textAlign: 'center',
    borderRadius: 5,
  },
});

export default DebounceButton;
